import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faDoorOpen } from '@fortawesome/pro-solid-svg-icons/faDoorOpen';
import { faHatCowboy } from '@fortawesome/pro-solid-svg-icons/faHatCowboy';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { faCloudUpload } from '@fortawesome/pro-solid-svg-icons/faCloudUpload';
import { faSuitcase } from '@fortawesome/pro-solid-svg-icons/faSuitcase';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faPlusSquare } from '@fortawesome/pro-solid-svg-icons/faPlusSquare';
import { faFolderTree } from '@fortawesome/pro-solid-svg-icons/faFolderTree';
import { useTheme, isDark, renderItem, Block, toggle, UserAvatar, Dropdown } from '@snapper/core';
import { AnimatePresence } from 'framer-motion';
import { library } from '@fortawesome/fontawesome-svg-core';
import { S as SearchInput, N as NotificationWrapper, M as MobileWrapper } from './input-styles-edfcc09c.js';
import { useSearch } from './hooks/use-search.js';
import { m as menuDefinitions } from './menu-items-e4a4881c.js';
import { Context } from './menu-context.js';
import '@emotion/react';
import 'axios';
import '@fortawesome/pro-solid-svg-icons/faCaretDown';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var img = "data:image/svg+xml,%3csvg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M10.4417 17.5C10.2952 17.7526 10.0849 17.9622 9.83185 18.108C9.57884 18.2537 9.29198 18.3304 9 18.3304C8.70802 18.3304 8.42116 18.2537 8.16814 18.108C7.91513 17.9622 7.70484 17.7526 7.55833 17.5M14 6.66669C14 5.3406 13.4732 4.06883 12.5355 3.13115C11.5979 2.19347 10.3261 1.66669 9 1.66669C7.67392 1.66669 6.40215 2.19347 5.46447 3.13115C4.52678 4.06883 4 5.3406 4 6.66669C4 12.5 1.5 14.1667 1.5 14.1667H16.5C16.5 14.1667 14 12.5 14 6.66669Z' stroke='white' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";
var bellNotification = img;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
library.add(faThumbsUp, faUser, faUsers, faPlusSquare, faSearch, faFolderTree, faDoorOpen, faChevronUp, faCloudUpload, faHatCowboy, faSuitcase, faChevronRight, faChevronDown, faChevronLeft);
var hasAttach = function hasAttach(item, attach) {
  var _item$attach;
  return !('attach' in item) || ((_item$attach = item.attach) === null || _item$attach === void 0 ? void 0 : _item$attach.includes(attach)) || false;
};
var Menu = function Menu(_ref) {
  var className = _ref.className,
    history = _ref.history,
    _ref$data = _ref.data,
    logo = _ref$data.logo,
    _ref$data$isMobile = _ref$data.isMobile,
    isMobile = _ref$data$isMobile === void 0 ? false : _ref$data$isMobile,
    _ref$data$config = _ref$data.config;
  _ref$data$config = _ref$data$config === void 0 ? {} : _ref$data$config;
  var _ref$data$config$prim = _ref$data$config.primaryColor,
    primaryColor = _ref$data$config$prim === void 0 ? '#7A3BCD' : _ref$data$config$prim,
    _ref$data$config$text = _ref$data$config.textColor,
    textColor = _ref$data$config$text === void 0 ? '#ffffff' : _ref$data$config$text,
    _ref$data$config$offs = _ref$data$config.offset,
    offset = _ref$data$config$offs === void 0 ? 200 : _ref$data$config$offs,
    width = _ref$data$config.width,
    search = _ref$data.search,
    items = _ref$data.items,
    profile = _ref$data.profile,
    buttons = _ref$data.buttons,
    dropdownWrapperComponent = _ref.dropdownWrapperComponent;
  var _useState = useState(null),
    activeMenu = _useState[0],
    setActiveMenu = _useState[1];
  var _useState2 = useState(false),
    showSearchResults = _useState2[0],
    setShowSearchResults = _useState2[1];
  var _useState3 = useState(false),
    showProfileMenu = _useState3[0],
    setShowProfileMenu = _useState3[1];
  var _useState4 = useState(false),
    showMobileMenu = _useState4[0],
    setShowMobileMenu = _useState4[1];
  var _useState5 = useState(''),
    searchTerm = _useState5[0],
    setSearchTerm = _useState5[1];
  var ref = useRef(null);
  var theme = useTheme();
  var closeMenu = useCallback(function () {
    setShowSearchResults(false);
    setActiveMenu(null);
    setShowProfileMenu(false);
    setShowMobileMenu(false);
  }, []);
  var darkColor = isDark(primaryColor);
  var context = useMemo(function () {
    return {
      history: history,
      isMobile: isMobile,
      activeMenu: activeMenu,
      className: className,
      closeMenu: closeMenu,
      theme: theme,
      darkColor: darkColor,
      textColor: textColor,
      setActiveMenu: setActiveMenu,
      setShowProfileMenu: setShowProfileMenu,
      setShowMobileMenu: setShowMobileMenu
    };
  }, [history, isMobile, activeMenu, className, closeMenu, theme, darkColor, textColor]);
  var _useSearch = useSearch(search, context),
    doSearch = _useSearch.search,
    searchResult = _useSearch.searchResult;
  useEffect(function () {
    if (searchResult) {
      setShowSearchResults(true);
    }
  }, [searchResult]);
  useEffect(function () {
    if (showSearchResults) {
      setActiveMenu(null);
      setShowProfileMenu(false);
    }
  }, [showSearchResults]);
  useEffect(function () {
    if (activeMenu) {
      setShowSearchResults(false);
      setShowProfileMenu(false);
    }
  }, [activeMenu]);
  var renderItems = useCallback(function (items) {
    return (items === null || items === void 0 ? void 0 : items.map(function (item, index) {
      return renderItem(_objectSpread(_objectSpread({}, item), {}, {
        index: index
      }), menuDefinitions, context);
    })) || null;
  }, [context]);
  var menuItems = useMemo(function () {
    return renderItems(items === null || items === void 0 ? void 0 : items.filter(function (item) {
      return hasAttach(item, isMobile ? 'mobile' : 'desktop');
    }));
  }, [isMobile, items, renderItems]);
  var menuButtons = useMemo(function () {
    return renderItems(buttons === null || buttons === void 0 ? void 0 : buttons.filter(function (item) {
      return hasAttach(item, isMobile ? 'mobile' : 'desktop');
    }));
  }, [isMobile, buttons, renderItems]);
  var menuContent = useMemo(function () {
    if (showSearchResults && searchResult && searchResult !== null && searchResult !== void 0 && searchResult.result) {
      // Show content from search result directly if 'result' key is non-empty
      return searchResult.result || null;
    }
    if (!showSearchResults && isMobile && showMobileMenu) {
      var _profile$items;
      console.log('here....', activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.items[0]); // If mobile menu is opened, show the regular menu items/buttons

      return jsxs(Fragment, {
        children: [jsx("div", {
          className: "close",
          onClick: function onClick() {
            closeMenu();
          },
          children: jsx(FontAwesomeIcon, {
            icon: faTimes
          })
        }), jsxs("div", {
          className: "content",
          children: [activeMenu || showProfileMenu ? jsxs(Block, {
            className: "parent",
            row: true,
            style: {
              paddingLeft: 20
            },
            onClick: function onClick() {
              setActiveMenu(null);
              setShowProfileMenu(false);
            },
            children: [jsx(FontAwesomeIcon, {
              icon: faChevronLeft
            }), showProfileMenu ? profile === null || profile === void 0 ? void 0 : profile.displayName : activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.title]
          }) : null, Boolean(activeMenu !== null || showProfileMenu) && jsx(Fragment, {
            children: showProfileMenu && jsx("div", {
              children: renderItems(profile === null || profile === void 0 ? void 0 : (_profile$items = profile.items) === null || _profile$items === void 0 ? void 0 : _profile$items.filter(function (item) {
                return hasAttach(item, 'mobile');
              }))
            }) || jsx(Fragment, {
              children: activeMenu && jsx(Fragment, {
                children: activeMenu.items.map(function (activeItem) {
                  return jsx(Fragment, {
                    children: renderItems(activeItem.filter(function (item) {
                      return hasAttach(item, 'mobile');
                    }))
                  });
                })
              })
            })
          }) || jsxs(Fragment, {
            children: [profile && profile.displayName && jsxs("div", {
              className: "menu-item profile",
              onClick: function onClick() {
                if (!profile.items) {
                  return;
                }
                setShowProfileMenu(true);
              },
              children: [profile.displayName, !!profile.items && jsx("div", {
                className: "more",
                children: jsx(FontAwesomeIcon, {
                  icon: ['fal', 'chevron-right']
                })
              })]
            }), menuItems, menuButtons]
          })]
        })]
      });
    } // Show profile menu or search result items

    var showItems = showProfileMenu && (profile === null || profile === void 0 ? void 0 : profile.items) || showSearchResults && (searchResult === null || searchResult === void 0 ? void 0 : searchResult.items);
    var attachType = isMobile ? 'mobile' : 'desktop';
    return showItems ? renderItems(showItems.filter(function (item) {
      return hasAttach(item, attachType);
    })) : null;
  }, [activeMenu, closeMenu, isMobile, menuButtons, menuItems, profile, renderItems, searchResult, showMobileMenu, showProfileMenu, showSearchResults]);
  useEffect(function () {
    var onKeyDown = function onKeyDown(_ref2) {
      var key = _ref2.key;
      if (key === 'Escape') {
        closeMenu();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [closeMenu]);
  return jsxs(Context.Provider, {
    value: context,
    children: [jsx(Block, {
      ref: ref,
      background: primaryColor,
      className: className,
      row: true,
      style: {
        justifyContent: 'space-between'
      },
      height: "70px",
      padding: "0 20px",
      justify: "left",
      overflow: "hidden",
      children: isMobile ? jsxs(Fragment, {
        children: [jsx(Block, {
          grow: true,
          justify: "left",
          children: (logo === null || logo === void 0 ? void 0 : logo.src) && (logo.href ? jsx("a", {
            href: logo.href,
            children: jsx("img", {
              className: "logo",
              style: {
                maxHeight: '34px',
                maxWidth: '150px'
              },
              src: logo.src,
              height: logo.height,
              alt: logo.alt,
              title: logo.title
            })
          }) : jsx("img", {
            src: logo.src,
            height: "auto",
            alt: logo.alt,
            title: logo.title
          }))
        }), jsx(Block, {
          className: "menu-ico",
          justify: "right",
          css: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            setShowMobileMenu(toggle);
          },
          children: jsx(FontAwesomeIcon, {
            className: "toggle-mobile-menu",
            icon: showMobileMenu ? faTimes : faBars,
            style: {
              fontSize: 30
            },
            color: "white"
          })
        })]
      }) : jsxs(Block, {
        row: true,
        grow: true,
        shrink: true,
        maxWidth: width,
        className: "menu-top-row-container",
        children: [jsx(Block, {
          grow: true,
          shrink: true,
          justify: "left",
          maxWidth: offset,
          children: (logo === null || logo === void 0 ? void 0 : logo.src) && (logo.href ? jsx("a", {
            href: logo.href,
            children: jsx("img", {
              className: "logo",
              src: logo.src,
              height: logo.height,
              alt: logo.alt,
              title: logo.title,
              style: {
                maxHeight: '34px',
                maxWidth: '150px'
              }
            })
          }) : jsx("img", {
            src: logo.src,
            height: logo.height,
            alt: logo.alt,
            title: logo.title
          }))
        }), jsx(Block, {
          row: true,
          justify: "left",
          color: "black",
          marginLeft: "20px",
          marginBetween: "20px",
          className: "menu-items-container",
          children: menuItems
        }), jsxs(Block, {
          row: true,
          grow: true,
          shrink: true,
          justify: "right",
          marginLeft: "20px",
          marginBetween: "20px",
          color: "#fff",
          children: [search && jsx(SearchInput, {
            type: "text",
            placeholder: search.placeholder,
            onClick: function onClick() {
              if (searchResult) {
                setShowSearchResults(true);
              } else {
                doSearch(searchTerm);
              }
              setActiveMenu(null);
              setShowProfileMenu(false);
            },
            value: searchTerm,
            onChange: function onChange(_ref3) {
              var value = _ref3.target.value;
              setSearchTerm(value || '');
              doSearch(value || '');
            }
          }), menuButtons, profile && profile.displayName && jsxs(Block, {
            nowrap: true,
            row: true,
            justify: "center",
            padding: "8px 12px",
            background: showProfileMenu ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0)',
            hoverBackground: showProfileMenu ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.2)',
            borderRadius: "5px",
            className: "profile-container",
            style: {
              cursor: 'pointer',
              color: textColor ? textColor : darkColor ? '#FFF' : '#000'
            },
            onClick: function onClick() {
              setShowProfileMenu(toggle);
              setShowSearchResults(false);
              setActiveMenu(null);
            },
            children: [(profile === null || profile === void 0 ? void 0 : profile.notification) && jsxs(NotificationWrapper, {
              className: "active",
              children: [jsx("img", {
                src: bellNotification
              }), jsx("div", {
                className: "ico"
              })]
            }) || jsx(UserAvatar, {
              css: {
                display: 'inline',
                marginRight: '0.5em'
              },
              size: 32,
              backgroundColor: "#CCC",
              name: profile.displayName,
              src: profile.avatarUrl,
              labelScale: 0.8
            }), profile.displayName]
          })]
        })]
      })
    }), isMobile ? jsx(AnimatePresence, {
      children: !!menuContent && jsx(MobileWrapper, {
        children: menuContent
      }, "mobile-menu")
    }) : !!menuContent && jsx(Dropdown, {
      WrapperComponent: dropdownWrapperComponent,
      onClose: closeMenu,
      parentRef: ref,
      className: className,
      alignBottom: true,
      alignRight: !isMobile,
      grow: true,
      shadow: true,
      shrink: true,
      base: true,
      children: jsx(Block, {
        background: "#fff",
        border: true,
        borderTop: false,
        padding: "40px",
        column: true,
        width: "100vw",
        maxWidth: !isMobile ? showProfileMenu ? '600px' : '800px' : undefined,
        marginBetween: "20px",
        shadow: true,
        children: menuContent
      })
    })]
  });
};
export { Menu };